module.exports = "/images/ny-life1-8.jpg";